/* MadMouse — Horizontal scroller con flechas.
   Reutilizable en cualquier sección: envuelve un viewport con scroll-x y dos
   botones. Las flechas se ocultan automáticamente cuando no hay nada que
   scrollear (todo cabe en el ancho actual) o al llegar a los extremos.

   Markup esperado:
   <div data-mm-hscroll>
     <button data-mm-hscroll-prev>…</button>
     <div data-mm-hscroll-viewport> … contenido scrolleable … </div>
     <button data-mm-hscroll-next>…</button>
   </div>

   Guard de inicialización única: aunque varias secciones incluyan este asset,
   solo se ejecuta una vez y atiende a TODOS los [data-mm-hscroll] del documento. */
(function () {
  if (typeof window === 'undefined' || window.__mmHscrollInit) return;
  window.__mmHscrollInit = true;

  var init = function () {
    document.querySelectorAll('[data-mm-hscroll]').forEach(function (root) {
      if (root.__mmHscrollBound) return;
      root.__mmHscrollBound = true;

      var vp = root.querySelector('[data-mm-hscroll-viewport]');
      var prev = root.querySelector('[data-mm-hscroll-prev]');
      var next = root.querySelector('[data-mm-hscroll-next]');
      if (!vp || !prev || !next) return;

      var update = function () {
        var max = vp.scrollWidth - vp.clientWidth;
        var scrollable = max > 4;
        prev.hidden = !scrollable || vp.scrollLeft <= 4;
        next.hidden = !scrollable || vp.scrollLeft >= max - 4;
      };

      var step = function (dir) {
        vp.scrollBy({ left: dir * Math.max(vp.clientWidth * 0.8, 200), behavior: 'smooth' });
      };

      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      vp.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      /* Recalcular cuando carguen imágenes (cambia scrollWidth) */
      vp.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', update, { once: true });
      });

      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
